/** Build a printable emergency / recovery kit (master password is NOT included). */

export function buildRecoveryKit(opts: {
  email: string;
  createdAt?: Date;
}): string {
  const when = (opts.createdAt || new Date()).toISOString();
  const lines = [
    "CipherNest — Emergency Kit",
    "==========================",
    "",
    "Keep this file offline (print or encrypted drive). Anyone with your",
    "master password can open your vault.",
    "",
    `Created:     ${when}`,
    `Account:     ${opts.email}`,
    "",
    "Master password",
    "---------------",
    "Write your master password here after printing, then store safely:",
    "",
    "________________________________________________",
    "",
    "Hint (optional): ________________________________",
    "",
    "Important",
    "---------",
    "- CipherNest cannot reset a forgotten master password.",
    "- Autofill on this device lasts up to 14 days after unlock.",
    "- After changing your master password, set up PIN / fingerprint again.",
    "- Keep a recent vault export as an offline backup.",
    "",
    "Support",
    "-------",
    "Open the CipherNest app → More → Security for autofill and lock settings.",
    "",
  ];
  return lines.join("\n");
}
